import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal, Backdrop, Fade, Typography, Button, TextField, Input } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { validatePassword } from "../../../utils/general";
import Alert from "../../layout/Alert";
import { changePassword } from "../../../action/password";
import customConfig from "../../../config";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: "#fff",
    borderRadius: 8,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(4, 4, 3),
    minWidth: 350,
    outline: "none",
  },
  formField: {
    marginBottom: theme.spacing(2),
  },
  actions: {
    display: "flex",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
  },
}));

const ChangePassword = ({ open, onClose, changePassword }) => {
  const classes = useStyles();
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");
    if (!newPassword || !confirmPassword) {
      setError("Please fill both fields.");
      return;
    }
    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    const { valid, error: validationError } = validatePassword(newPassword);
    if (!valid) {
      setError(validationError);
      return;
    }
    changePassword( newPassword )
      .then(() => {
        setNewPassword("");
        setConfirmPassword("");
        onClose();
    })
    .catch((err) => {
        setError(customConfig.passwordChangeError);
    });
  };

  const handleCancel = () => {
    setNewPassword("");
    setConfirmPassword("");
    setError("");
    onClose();
  };

  return (
    <Modal
      open={open}
      onClose={handleCancel}
      className={classes.modal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 300 }}
    >
      <Fade in={open}>
        <form className={classes.paper} onSubmit={handleSubmit}>
          <Typography variant="h6" gutterBottom>
            Change Password
          </Typography>
          <TextField
            label="New Password"
            type="password"
            fullWidth
            InputProps={{ disableUnderline: true }}
            className={classes.formField}
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            autoFocus
          />
          <TextField
            label="Confirm New Password"
            type="password"
            InputProps={{ disableUnderline: true }}
            fullWidth
            className={classes.formField}
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
          />
          {error && (
            <Typography color="error" variant="body2" className={classes.formField}>
              {error}
            </Typography>
          )}
          <div className={classes.actions}>
            <Button onClick={handleCancel} color="secondary">
              Cancel
            </Button>
            <Button type="submit" color="primary" variant="contained">
              Submit
            </Button>
          </div>
        </form>
      </Fade>
    </Modal>
  );
}

const mapDispatchToProps = (dispatch) => ({
  changePassword: (newPassword) => dispatch(changePassword(newPassword)),
});

export default connect(null, mapDispatchToProps)(ChangePassword);
